import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { RestService } from '../../../services/rest/rest.service';
import { isString, isArray } from '../../../models/utils';
import { HelpIndex, Endpoint } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { DrObject, SupportedRegExType } from '../../../models/dr-object';
import { PopoverDirective } from 'ngx-bootstrap/popover';

export enum MetadataFields {
    Custodian = 'Custodian',
    MediaID = 'Media ID',
    Batch = 'Batch'
}

@Component({
    standalone: false,
    selector: 'res-update-metadata-modal',
    templateUrl: './update-metadata-modal.component.html',
    styleUrls: ['./update-metadata-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class UpdateMetadataModalComponent extends BaseModalComponent {
    @ViewChild('errorPopover', { static: true }) errorPopover: PopoverDirective;
    selectedMetadata = MetadataFields.Custodian;
    metadataValue: string;
    metadataFields = MetadataFields;
    modalHelpIndex = HelpIndex.update_metadata_dlg;
    modalAutomationId = 'update-metadata';
    drObject: DrObject;
    errorMessage: string;
    hasError: boolean;
    isBusy = false;
    isBusyMessage: string;
    isRemoveValue: false;

    constructor(private modalService: BsModalService, private commonService: CommonService, private modalRef: BsModalRef, private restService: RestService) {
        super(modalService, modalRef);
    }

    isPrimaryButtonEnabled(): boolean {
        return (this.selectedMetadata && this.metadataValue && this.metadataValue.trim() !== '' && !this.hasError) || this.isRemoveValue;
    }

    validateNameCharacters() {
        if (this.metadataValue) {
            const drObject = new DrObject();
            drObject.regex = SupportedRegExType.METADATAVIEW;
            const errorMessage = drObject.uiValidateName(this.metadataValue);
            if (errorMessage) {
                this.errorMessage = errorMessage;
                this.hasError = true;
                this.errorPopover.show();
            } else {
                this.hasError = false;
                this.errorMessage = '';
                this.errorPopover.hide();
            }
        } else {
            this.errorPopover.hide();
        }
    }

    validateOnBlur(selectedMetadata: MetadataFields): Promise<boolean> {
        if (this.metadataValue) {
            return new Promise<boolean>((resolve) => {
                const objectType = selectedMetadata === 'Media ID' ? 'MEDIAID' : selectedMetadata.toUpperCase();
                this.isBusy = true;
                this.isBusyMessage = 'Validating the new matadata field ...';

                this.restService.post(Endpoint.viewManager_validateName, {
                    name: this.metadataValue,
                    contextHandle: this.commonService.currentProject.handle,
                    objectType: objectType,
                    projectHandle: this.commonService.currentProject.handle,
                    requestHandle: null,
                    skipNameValidation: true
                }).then(response => {
                    this.isBusy = false;
                    this.isBusyMessage = '';
                    if (response.reason) {
                        this.hasError = true;
                        this.errorMessage = response.reason;
                        this.errorPopover.show();
                        resolve(false);
                    } else {
                        this.hasError = false;
                        this.errorMessage = '';
                        this.errorPopover.hide();
                        resolve(true);
                    }
                }, error => {
                    this.hasError = false;
                    this.errorPopover.show();
                    this.isBusy = false;
                    resolve(false);
                });
            });
        } else {
            return Promise.resolve(false);
        }
    }

    ok(): void {
        this.validateOnBlur(this.selectedMetadata).then(valid => {
            if (this.modalData && this.modalData.docHandles) {
                this.isBusyMessage = 'Updating Metadata...';
                this.isBusy = true;
                const requestData = { metadataUpdates: this.selectedMetadata === MetadataFields.MediaID ? { MediaID: this.metadataValue } : { [this.selectedMetadata]: this.metadataValue } };
                const viewHandle = this.commonService.matrixGridsSelection?.openFromDocumentActionBtn ? this.commonService.matrixGridsSelection?.viewHandle : this.modalData?.selectedNode?.data?.handle;
                this.restService.post(Endpoint.viewManager_canUpdateMetadata, { handle: viewHandle }).then(responseCanUpdateMetadata => {
                    if (responseCanUpdateMetadata && responseCanUpdateMetadata.percentComplete === 100) {
                        this.restService.post(Endpoint.viewManager_canUpdateMetadataResult, { handle: responseCanUpdateMetadata.handle }).then(responseCanUpdateMetadataResult => {
                            this.isBusy = false;
                            if (responseCanUpdateMetadataResult?.valid) {
                                if (isString(this.modalData.docHandles)) {
                                    Object.assign(requestData, { viewHandle: this.modalData.docHandles });
                                    this.restService.post(Endpoint.corpusManager_updateMetadataForViewDocuments, requestData);
                                } else if (isArray(this.modalData.docHandles)) {
                                    Object.assign(requestData, { documentHandleList: this.modalData.docHandles });
                                    this.restService.post(Endpoint.corpusManager_updateMetadataForDocuments, requestData);
                                }
                                this.closeModal();
                            } else {
                                if (responseCanUpdateMetadataResult?.reason) {
                                    this.commonService.openWarningModal(responseCanUpdateMetadataResult.reason);
                                }
                            }
                        }, error => {
                            this.isBusy = false;
                        });
                    }
                }, error => {
                    this.isBusy = false;
                });
            }
        });
    }

    onIsRemoveValue() {
        if (this.isRemoveValue) {
            this.metadataValue = null;
        }
    }
}